<template>
  <div id="center">
    <!-- <div>
      <span>
        <icon name="chart-pie" class="text-icon"></icon>
      </span>
      <span class="fs-xl text mx-2 mb-1 pl-3">年度负责人组件达标榜</span>
    </div> -->
    <div class="d-flex u-jsb pt-2 pl-2 mar">
      <div class="u-f u-ac">
        <span>
          <icon name="chart-pie" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">数据总览</span>
        </div>
      </div>
      <div class="rzy_qh u-f u-ac">
        <div class="qh_btn" @click="ridata(1)">日</div>
        <div class="qh_btn" @click="ridata(3)">周</div>
        <div class="qh_btn" @click="ridata(2)">月</div>
      </div>

    </div>
    <div class="up">
      <div class="bg-color-black item" v-for="item in titleItem.filter(a=>{return a.show==tog})" :key="item.title">
        <p class="ml-3 colorBlue fw-b fs-xl">{{ item.title }}</p>
        <div>
          <!-- <dv-digital-flop class="dv-dig-flop ml-1 mt-2 pl-3" :config="item.number" /> -->
          <div class="dv-dig-flop ml-1 mt-2 pl-3 numbers">{{item.number}}</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import CenterChart from '@/components/echart/center/centerChartRate'

  export default {
    props: ['inquiry', 'userRegister', 'docRegister', 'phoneUser'],
    data() {
      return {
        titleItem: [{
            title: '用户今日关注新增',
            number: 100,
            show:1,
          },
          {
            title: '用户本周关注新增',
            number: 0,
            show:3,
          },
          {
            title: '用户本月关注新增',
            number: 0,
            show:2,
          },
          {
            title: '用户今日注册新增',
            number: 0,
            show:1,
          },
          {
            title: '用户本周注册新增',
            number: 0,
            show:3,
          },
          {
            title: '用户本月注册新增',
            number: 0,
            show:2,
          },
          {
            title: '医生今日关注新增',
            number: 0,
            show:1,
          },
          {
            title: '医生本周关注新增',
            number: 0,
            show:3,
          },
          {
            title: '医生本月关注新增',
            number: 0,
            show:2,
          },
          {
            title: '医生今日注册新增',
            number: 0,
            show:1,
          },
          {
            title: '医生本周注册新增',
            number: 0,
            show:3,
          },
          {
            title: '医生本月注册新增',
            number: 0,
            show:2,
          },
          // {
          //   title: '用户总量',
          //   number: 0
          // },
          // {
          //   title: '注册总量',
          //   number: 0
          // },
          // {
          //   title: '医生总量',
          //   number: 0
          // },

        ],
     
        water: {
          data: [24, 45],
          shape: 'roundRect',
          formatter: '{value}%',
          waveNum: 3
        },
        // 通过率和达标率的组件复用数据
        rate: [{
            id: 'centerRate1',
            tips: 60,
            colorData: {
              textStyle: '#3fc0fb',
              series: {
                color: ['#00bcd44a', 'transparent'],
                dataColor: {
                  normal: '#03a9f4',
                  shadowColor: '#97e2f5'
                }
              }
            }
          },
          {
            id: 'centerRate2',
            tips: 40,
            colorData: {
              textStyle: '#67e0e3',
              series: {
                color: ['#faf3a378', 'transparent'],
                dataColor: {
                  normal: '#ff9800',
                  shadowColor: '#fcebad'
                }
              }
            }
          }
        ],
        tog:1,
      }
    },
    components: {
      CenterChart
    },
    watch: {
      inquiry: {
        handler(n) {
          // this.titleItem[0].number = n.total_count ? n.total_count - 0 : 0
          // this.titleItem[1].number = n.total_price ? n.total_price - 0 : 0
        },
        immediate: true,
        deep: true
      },
      userRegister: {
        handler(n) {
          this.titleItem[0].number = n.user_day_count ? n.user_day_count : 0
          this.titleItem[1].number = n.user_week_count ? n.user_week_count : 0
          this.titleItem[2].number = n.user_month_count ? n.user_month_count : 0
          // this.titleItem[9].number = n.user_total_count ? n.user_total_count : 0
        },
        immediate: true,
        deep: true
      },
      docRegister: {
        handler(n) {
          this.titleItem[6].number = n.doc_day_count ? n.doc_day_count : 0
          this.titleItem[9].number = n.doc_day_count ? n.doc_day_count : 0
          this.titleItem[7].number = n.doc_week_count ? n.doc_week_count : 0
          this.titleItem[10].number = n.doc_week_count ? n.doc_week_count : 0
          this.titleItem[8].number = n.doc_month_count ? n.doc_month_count : 0
          this.titleItem[11].number = n.doc_month_count ? n.doc_month_count : 0
          // this.titleItem[11].number = n.doc_total_count ? n.doc_total_count : 0
        },
        immediate: true,
        deep: true
      },
      phoneUser: {
        handler(n) {
          this.titleItem[3].number = n.day_count ? n.day_count : 0
          this.titleItem[4].number = n.week_count ? n.week_count : 0
          this.titleItem[5].number = n.month_count ? n.month_count : 0
          // this.titleItem[10].number = n.total_count ? n.total_count : 0
        },
        immediate: true,
        deep: true
      },
    },
    methods:{
      ridata(r){
        this.tog=r
      }
    }
  }
</script>

<style lang="scss" scoped>
  #center {
    display: flex;
    flex-direction: column;

    .mar {
      margin-top: 18px;
      margin-left: 10px;
      .rzy_qh{
        margin-right: 10px;
        .qh_btn{
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }

    .up {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      padding: 0 13px;

      .item {
        border-radius: 6px;
        padding-top: 8px;
        margin-top: 8px;
        width: 99%;
        height: 80px;

        .dv-dig-flop {
          width: 150px;
          height: 30px;
        }

        .numbers {
          color: #7ec699;
          font-size: 26px;
          font-weight: 700;
        }
      }
    }

    .down {
      padding: 6px 4px;
      padding-bottom: 0;
      width: 100%;
      display: flex;
      height: 255px;
      justify-content: space-between;

      .bg-color-black {
        border-radius: 5px;
      }

      .ranking {
        padding: 10px;
        width: 59%;

        .dv-scr-rank-board {
          height: 225px;
        }
      }

      .percent {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 10px;

        .item {
          width: 50%;
          height: 210px;
          border-radius: 5px;
          overflow: hidden;

          span {
            margin-top: 8px;
            font-size: 14px;
            display: flex;
            justify-content: center;
          }
        }

        .water {
          width: 100%;

          .dv-wa-le-po {
            height: 120px;
          }
        }
      }
    }
  }
</style>